import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '../../../../assets/icons/close-circle.svg';
import { ReactComponent as PreviousArrow } from '../../../../assets/icons/navigate-back.svg';
import { useAppSelector } from '../../../../redux/hooks';

import DeviceDetailsTopContainer from './device-details/DeviceDetailsTopContainer';

interface DeviceViewModelProperties {
  open: boolean;
  handleCloseModal: () => void;
}

/**
 * Device view model
 * @param {any} properties - The properties
 * @returns {any} The result
 */
function DeviceViewModel(properties: DeviceViewModelProperties) {
  const navigate = useNavigate();
  const { selectedChargingPoint } = useAppSelector((state) => state.device);

  const { open, handleCloseModal } = properties;

  /**
   * Function to navigate to device management screen
   */
  const navigateToDevicePage = () => {
    if (selectedChargingPoint) {
      navigate({
        pathname: `./device/${selectedChargingPoint.id}/device-details`,
        search: `?searchBy=${selectedChargingPoint.name}`,
      });
    }
  };

  const reference = useRef<HTMLDivElement>(null);
  /**
   * Click the outside page function
   * @param {any} event - The event
   */
  const handleClickOutside = (event: React.MouseEvent) => {
    if (reference.current === event.target) {
      handleCloseModal();
    }
  };

  return open
    ? ReactDOM.createPortal(
        <div
          role="presentation"
          className="device-view-model-wrap"
          ref={reference}
          onClick={handleClickOutside}>
          <div className="device-view-model-container">
            <div className="open-model-in-full-view">
              <span role="presentation" onClick={navigateToDevicePage}>
                <PreviousArrow />
              </span>
            </div>
            <div className="device-view-model-data">
              <DeviceDetailsTopContainer />
            </div>
            <span className="close-icon" role="presentation" onClick={handleCloseModal}>
              <CloseIcon />
            </span>
          </div>
        </div>,
        document.body,
      )
    : null;
}

export default DeviceViewModel;
